import React, {Fragment} from "react";
import InputErrorMessage from "../InputErrorMessage";

function PersonInitialForm({offerWithCalculation, formValidator, onChange}) {

    const personValueChangeHandler = (event) => {
        const {name, value} = event.target;

        onChange({...offerWithCalculation, [name]: value});
    }

    return (
        <Fragment>
            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="firstName">Imię</label>
                <input type="text"
                       id="firstName"
                       ref={formValidator.register({required: true})}
                       name="firstName"
                       value={offerWithCalculation.firstName}
                       onChange={personValueChangeHandler}/>
                <InputErrorMessage error={formValidator.errors.firstName} message="Podaj swoje imię"/>
            </div>
            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="email">Adres e-mail</label>
                <input type="email"
                       id="email"
                       ref={formValidator.register({required: true})}
                       name="email"
                       value={offerWithCalculation.email}
                       onChange={personValueChangeHandler}/>
                <InputErrorMessage error={formValidator.errors["email"]} message="Podaj poprawny adres e-mail"/>
            </div>
            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="phoneNumber">Nr telefonu</label>
                <input type="text"
                       id="phoneNumber"
                       ref={formValidator.register({
                           required: true,
                           pattern: /[0-9]{9}/,
                           maxLength: 9
                       })}
                       name="phoneNumber"
                       value={offerWithCalculation.phoneNumber}
                       onChange={personValueChangeHandler}
                       placeholder="Np. 753421869 (9 cyfr)"/>
                <InputErrorMessage error={formValidator.errors["phoneNumber"]} message="Podaj poprawny numer telefonu"/>
            </div>
        </Fragment>
    );

}

export default PersonInitialForm;